import { render, staticRenderFns } from "./Edit_origin.vue?vue&type=template&id=6987110e&"
import script from "./Edit_origin.vue?vue&type=script&lang=js&"
export * from "./Edit_origin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports